import { Fragment } from "react";
import { Link } from "react-router-dom";
import { cn } from "../../utils/cn";
import { getAdminEntityUrl } from "../../utils/helpers";

// A reference to another entity, rendered as a link to its detail modal when
// the id is known and as plain text otherwise (legacy refs, unknown types).
// `newTab` keeps a review queue's place: duplicate and image review open links
// in a new tab, detail modals navigate in place.
export function EntityLink({ type, id, newTab = false, className, children, ...props }) {
  const url = getAdminEntityUrl(type, id);
  if (!url) return <span className={className} {...props}>{children}</span>;
  return (
    <Link
      to={url}
      className={cn("hover:text-primary hover:underline", className)}
      {...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      {...props}
    >
      {children}
    </Link>
  );
}

// A comma-separated run of `EntityLink`s; each item is `{ id, name }`, labelled
// by its name, or its id when it has none.
export function EntityLinkList({ type, items, newTab = false }) {
  return items.map((item, i) => (
    <Fragment key={item.id || item.name}>
      {i > 0 && ", "}
      <EntityLink type={type} id={item.id} newTab={newTab}>{item.name || item.id}</EntityLink>
    </Fragment>
  ));
}
